import MediaQueries from './global/js/mediaqueries'
import { createPopper } from '@popperjs/core'
// https://swiperjs.com
import Swiper from 'swiper/bundle'

// Add libs to the windows object
window.createPopper = createPopper
window.Swiper = Swiper

new MediaQueries(document.querySelector('body'))
